webpackJsonp([267695594480457],{

/***/ 396:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(19);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(21);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TermsPage = function TermsPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'container grid-xl' },
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Terms' }),
	    _react2.default.createElement(
	      'section',
	      { className: 'terms section' },
	      _react2.default.createElement(
	        'div',
	        { className: 'columns' },
	        _react2.default.createElement(
	          'div',
	          { className: 'column col-8 col-md-12' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'red' },
	            '\u3054\u5229\u7528\u898F\u7D04'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'p',
	            null,
	            '\u3054\u5229\u7528\u306B\u3042\u305F\u3063\u3066\u306E\u304A\u9858\u3044'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            '\u3053\u306E\u30DB\u30FC\u30E0\u30DA\u30FC\u30B8\u3092\u3054\u5229\u7528\u9802\u304D\u307E\u3059\u524D\u306B\u3001\u4E0B\u8A18\u306E\u3054\u5229\u7528\u6761\u4EF6\u3092\u3088\u304F\u304A\u8AAD\u307F\u3044\u305F\u3060\u304D\u3001\u3054\u540C\u610F\u306E\u4E0A\u3054\u5229\u7528\u304A\u9858\u3044\u7533\u3057\u4E0A\u3052\u307E\u3059\u3002\u3054\u5229\u7528\u9802\u304D\u307E\u3057\u305F\u5834\u5408\u306B\u306F\u3001\u4E0B\u8A18\u306E\u8AF8\u6761\u4EF6\u3059\u3079\u3066\u306B\u3054\u540C\u610F\u9802\u3044\u305F\u3082\u306E\u3068\u3055\u305B\u3066\u9802\u304D\u307E\u3059\u3002'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            '\u3054\u5229\u7528\u6761\u4EF6'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'red' },
	            '1.\u8457\u4F5C\u6A29\u306B\u3064\u3044\u3066'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            '\u3053\u306E\u30DB\u30FC\u30E0\u30DA\u30FC\u30B8\u4E0A\u306E\u3059\u3079\u3066\u306E\u8457\u4F5C\u7269\u3001\u8096\u50CF\u3001\u30AD\u30E3\u30E9\u30AF\u30BF\u30FC\u3001\u30DE\u30FC\u30AF\u3001\u305D\u306E\u4ED6\u306E\u60C5\u5831\u306F\u3001\u5F53\u793E\u306A\u3044\u3057\u305D\u306E\u63D0\u4F9B\u8005\u304C\u8457\u4F5C\u6A29\u7B49\u306E\u77E5\u7684\u8CA1\u7523\u6A29\u3001\u53C8\u306F\u305D\u306E\u4F7F\u7528\u6A29\u305D\u306E\u4ED6\u306E\u6A29\u5229\u3092\u6709\u3057\u3066\u304A\u308A\u307E\u3059\u3002\u3053\u306E\u30DB\u30FC\u30E0\u30DA\u30FC\u30B8\u306E\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3001\u30D7\u30EA\u30F3\u30C8\u30A2\u30A6\u30C8\u305D\u306E\u4ED6\u306E\u65B9\u6CD5\u30FB\u624B\u6BB5\u306B\u3088\u308B\u8907\u88FD\u306F\u3001\u500B\u4EBA\u7684\u53C8\u306F\u5BB6\u5EAD\u5185\u3067\u306E\u9650\u3089\u308C\u305F\u7BC4\u56F2\u306B\u304A\u3051\u308B\u79C1\u7684\u4F7F\u7528\u306B\u9650\u308B\u3082\u306E\u3068\u3055\u305B\u3066\u9802\u304D\u307E\u3059\u3002\u3053\u306E\u30DB\u30FC\u30E0\u30DA\u30FC\u30B8\u5185\u306E\u60C5\u5831\u3084\u30D7\u30ED\u30B0\u30E9\u30E0\u3092\u3001\u4ED6\u306E\u30DB\u30FC\u30E0\u30DA\u30FC\u30B8\u3084\u5370\u5237\u7269\u306B\u8EE2\u7528\uFF08\u30B3\u30D4\u30FC\u3001\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3001\u63B2\u8F09\u3001\u5F15\u7528\u306A\u3069\uFF09\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'red' },
	            '2.\u5546\u6A19\u306B\u3064\u3044\u3066'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            '\u3053\u306E\u30DB\u30FC\u30E0\u30DA\u30FC\u30B8\u306B\u8868\u793A\u3055\u308C\u3066\u3044\u308B\u5546\u6A19\u306B\u95A2\u3059\u308B\u6A29\u5229\u306F\u3001\u5F53\u793E\u3001\u307E\u305F\u306F\u751F\u7523\u5143\u91B8\u9020\u6240\u304C\u305D\u306E\u4F7F\u7528\u3092\u8A8D\u3081\u305F\u6A29\u5229\u8005\u306B\u5E30\u5C5E\u3057\u307E\u3059\u3002\u6A29\u5229\u8005\u306B\u7121\u65AD\u3067\u4F7F\u7528\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'red' },
	            '3.\u30EA\u30F3\u30AF\u306E\u53D6\u6271\u306B\u3064\u3044\u3066'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            '\u5E0C\u671B\u3055\u308C\u308B\u65B9\u306F\u3001\u5F53\u793E\u56FD\u969B\u90E8\u8F38\u5165\u30D3\u30FC\u30EB\u4F01\u753B\uFF08',
	            _react2.default.createElement(
	              'a',
	              { href: 'mailto:beer@konishi.jp' },
	              'beer[at]konishi.jp'
	            ),
	            '\uFF09\u307E\u3067\u304A\u7533\u3057\u51FA\u4E0B\u3055\u3044\u3002\u691C\u8A0E\u5F8C\u3001\u3054\u9023\u7D61\u3092\u5DEE\u3057\u4E0A\u3052\u307E\u3059\u3002'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'red' },
	            '4.\u30E1\u30FC\u30EB\u306B\u3064\u3044\u3066'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            '\u304A\u5BA2\u69D8\u304B\u3089\u9802\u3044\u305F\u304A\u554F\u5408\u305B\u7B49\u306B\u3064\u3044\u3066\u3001\u5F53\u793E\u304B\u3089\u30E1\u30FC\u30EB\u306B\u3066\u304A\u8FD4\u4E8B\u3092\u5DEE\u3057\u4E0A\u3052\u308B\u5834\u5408\u3084\u3001\u304A\u5BA2\u69D8\u306B\u540C\u610F\u3092\u9802\u3044\u305F\u4E0A\u3067\u5F53\u793E\u304B\u3089\u69D8\u3005\u306A\u60C5\u5831\u3092\u30E1\u30FC\u30EB\u306B\u3066\u304A\u77E5\u3089\u305B\u3059\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002\u3053\u308C\u3089\u306E\u30E1\u30FC\u30EB\u306B\u3064\u3044\u3066\u306E\u8457\u4F5C\u6A29\u306F\u5F53\u793E\u306B\u5E30\u5C5E\u3057\u3066\u304A\u308A\u3001\u5F53\u793E\u306B\u7121\u65AD\u3067\u4ED6\u306E\u30DB\u30FC\u30E0\u30DA\u30FC\u30B8\u3084\u5370\u5237\u7269\u306A\u3069\u3078\u8EE2\u7528\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'red' },
	            '5\uFF0E\u30DB\u30FC\u30E0\u30DA\u30FC\u30B8\u63D0\u4F9B\u306E\u4E00\u6642\u4E2D\u65AD'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            '\u5F53\u793E\u306F\u3001\u30B7\u30B9\u30C6\u30E0\u306E\u4FDD\u5B88\u30FB\u969C\u5BB3\u3001\u706B\u707D\u30FB\u505C\u96FB\u3001\u5730\u9707\u7B49\u306E\u5929\u707D\u3001\u305D\u306E\u4ED6\u904B\u7528\u30FB\u6280\u8853\u4E0A\u3053\u306E\u30DB\u30FC\u30E0\u30DA\u30FC\u30B8\u63D0\u4F9B\u306E\u4E00\u6642\u4E2D\u65AD\u304C\u5FC5\u8981\u3067\u3042\u308B\u3068\u5224\u65AD\u3057\u305F\u5834\u5408\u306B\u306F\u3001\u4E8B\u524D\u306B\u901A\u77E5\u3059\u308B\u3053\u3068\u306A\u3057\u306B\u4E00\u6642\u4E2D\u65AD\u63AA\u7F6E\u3092\u3068\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002\u3053\u306E\u4E2D\u65AD\u306B\u3088\u308A\u751F\u3058\u305F\u640D\u5BB3\u306B\u3064\u3044\u3066\u306F\u3001\u4E00\u5207\u8CAC\u4EFB\u3092\u8CA0\u3044\u307E\u305B\u3093\u3002'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'red' },
	            '6.\u30DB\u30FC\u30E0\u30DA\u30FC\u30B8\u306E\u5909\u66F4'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            '\u5F53\u793E\u306F\u3001\u4E8B\u524D\u306B\u901A\u77E5\u3059\u308B\u3053\u3068\u306A\u304F\u3001\u3053\u306E\u30DB\u30FC\u30E0\u30DA\u30FC\u30B8\u306E\u5185\u5BB9\u3092\u5909\u66F4\u3059\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u306E\u3067\u3001\u4E88\u3081\u3054\u4E86\u627F\u4E0B\u3055\u3044\u3002'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'red' },
	            '7.\u514D\u8CAC\u4E8B\u9805\u306B\u3064\u3044\u3066'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            '\u5F53\u793E\u306F\u3001\u3053\u306E\u30DB\u30FC\u30E0\u30DA\u30FC\u30B8\u3067\u63D0\u4F9B\u3059\u308B\u60C5\u5831\u3001\u30D7\u30ED\u30B0\u30E9\u30E0\u3001\u5404\u7A2E\u30B5\u30FC\u30D3\u30B9\u3001\u305D\u306E\u4ED6\u30DB\u30FC\u30E0\u30DA\u30FC\u30B8\u306B\u95A2\u3059\u308B\u3059\u3079\u3066\u306E\u4E8B\u9805\u306B\u3064\u3044\u3066\u3001\u305D\u306E\u5B8C\u5168\u6027\u3001\u6B63\u78BA\u6027\u3001\u6709\u7528\u6027\u7B49\u306B\u3064\u304D\u3001\u3044\u304B\u306A\u308B\u4FDD\u8A3C\u3082\u81F4\u3057\u307E\u305B\u3093\u3002\u307E\u305F\u3001\u5F53\u793E\u306F\u3001\u3053\u306E\u30DB\u30FC\u30E0\u30DA\u30FC\u30B8\u306E\u3054\u5229\u7528\u306B\u8D77\u56E0\u3059\u308B\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3001\u30CF\u30FC\u30C9\u30A6\u30A7\u30A2\u4E0A\u306E\u4E8B\u6545\u3001\u3054\u5229\u7528\u8005\u9593\u53C8\u306F\u3054\u5229\u7528\u8005\u3068\u7B2C\u4E09\u8005\u306E\u9593\u306B\u304A\u3044\u3066\u751F\u3058\u305F\u30C8\u30E9\u30D6\u30EB\u3001\u305D\u306E\u4ED6\u306E\u4E8B\u6545\u7B49\u306B\u3088\u308B\u640D\u5BB3\u306E\u3059\u3079\u3066\u306B\u3064\u3044\u3066\u3001\u3044\u304B\u306A\u308B\u8CAC\u4EFB\u3082\u8CA0\u3044\u307E\u305B\u3093\u3002'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'red' },
	            '8.\u500B\u4EBA\u60C5\u5831\u306E\u4FDD\u8B77\u306B\u3064\u3044\u3066'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            '\u5F53\u793E\u306F\u3001\u304A\u5BA2\u69D8\u304B\u3089\u3054\u63D0\u4F9B\u9802\u3044\u305F\u500B\u4EBA\u60C5\u5831\u3092\u5C0A\u91CD\u3057\u3001\u500B\u4EBA\u60C5\u5831\u306E\u4FDD\u8B77\u306B\u52AA\u3081\u3066\u304A\u308A\u307E\u3059\u3002\u8A73\u3057\u304F\u306F\u300C',
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: 'privacy', className: 'red' },
	              '\u500B\u4EBA\u60C5\u5831\u306E\u4FDD\u8B77\u306B\u95A2\u3059\u308B\u57FA\u672C\u65B9\u91DD'
	            ),
	            '\u300D\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = TermsPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-terms-js-f52e326fd0302fba625d.js